import React from "react"
import { FormControl, Select, InputLabel, MenuItem, SelectChangeEvent, ThemeProvider, createTheme } from "@mui/material"
import { useNightMode } from "../../../contexts/NightModeContext"

type CommonSelectProps = {
  options: { label: string; value: string }[]
  value: string
  onChange: (event: SelectChangeEvent<string>) => void
  label: string
}

const CommonSelect = (props: CommonSelectProps) => {
  const { options, value, onChange, label } = props
  const { isNightMode } = useNightMode()
  if (options.length <= 1) return null;
  // Create dynamic theme based on night mode state
  const theme = createTheme({
    palette: {
      mode: isNightMode ? 'dark' : 'light',
    },
  })

  return (
    <ThemeProvider theme={theme}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={value}
          label={label}
          onChange={onChange}
          sx={{
            minWidth: '200px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: isNightMode ? '#333' : '#e0e0e0',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: isNightMode ? '#555' : '#bdbdbd',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: isNightMode ? '#90caf9' : '#1976d2',
            },
            '& .MuiSelect-icon': {
              color: isNightMode ? '#fff' : '#000',
            },
          }}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  )
}

export default CommonSelect